import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Map as ImmutableMap } from 'immutable';

import { FollowButton } from 'mastodon/components/follow_button';
import { IconButton } from 'mastodon/components/icon_button';
import { me } from 'mastodon/initial_state';

import { Avatar } from '../../../components/avatar';
import { DisplayName } from '../../../components/display_name';
import { CloseIcon } from 'mastodon/components/icons/close';

const messages = {
  title: { id: 'account.followers_list', defaultMessage: 'List of followers' },
  close: { id: 'bundle_modal_error.close', defaultMessage: 'Close' },
};

const FollowersModal = ({ accounts, onChangeBackgroundColor, onClose }) => {
  const intl = useIntl();

  React.useEffect(() => {
    onChangeBackgroundColor('rgba(0, 0, 0, 0.7)');
    return () => onChangeBackgroundColor(null);
  }, [onChangeBackgroundColor]);

  return (
    <div className={classNames('modal-root__modal', 'favourites-modal')}>
      <div className='favourites-modal-container'>
        <div className='favourites-modal__header'>
          <h3>{intl.formatMessage(messages.title)}</h3>
          <IconButton className='favourites-modal__close' title={intl.formatMessage(messages.close)} icon='close' iconComponent={CloseIcon} onClick={onClose} size={20} />
        </div>
        <div className='favourites-modal__content'>
            <ul className='favourites-modal__list'>
                {accounts.map((account) => {
                const name = account.display_name || account.username || "";

                const displayNameHtml =
                  name.length > 20 ? `${name.substring(0, 17)}...` : name;

                const accountMap = ImmutableMap({
                  ...account,
                  display_name_html: displayNameHtml,
                  roles: account.roles || [],
                });
                return (
                  <li key={account.id} className='favourites-modal__account'>
                    <Link
                      to={`/@${account.acct}`}
                      className='favourites-modal__account-link'
                      onClick={onClose}
                    >
                      <Avatar account={accountMap} size={40} />
                      <DisplayName account={accountMap} />
                    </Link>
                    {account.id !== me && <FollowButton compact accountId={account.id} /> }
                  </li>
                );
              })}
            </ul>
        </div>
      </div>
    </div>
  );
};

FollowersModal.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    acct: PropTypes.string.isRequired,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeBackgroundColor: PropTypes.func.isRequired,
};

export default FollowersModal;
